<div class="step-layout !mx-auto !flex !w-full !flex-col !gap-8">
    <header class="!flex !flex-col !gap-2">
        <p class="!mb-0 !text-xs !font-bold !uppercase !tracking-[0.08em] !text-primary">Passo 5 di 8</p>
        <h2 class="!mb-0 !text-[clamp(1.75rem,3vw,2.25rem)] !font-extrabold !leading-tight !text-strong">
            Servizi <span class="gradient-text">Well Done</span>
        </h2>
        <p class="!mb-0 !max-w-xl !text-base !leading-relaxed !text-subtle">
            Scegli il piano e se pagare mensile o annuale.
        </p>
    </header>

    <section class="!overflow-visible !rounded-2xl !border !border-solid !border-border !bg-white !p-6 md:!p-8"
             aria-labelledby="payg-title">
        <div class="!mb-5 !border-b !border-solid !border-slate-100 !pb-3">
            <h3 id="payg-title" class="!mb-1 !text-base !font-bold !text-strong">Paga se consumi</h3>
            <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                Pay-as-you-go: paghi solo l'uso effettivo del servizio, senza costi fissi vincolanti.
            </p>
        </div>
        <ul class="!mb-4 !flex !list-none !flex-col !gap-2.5 !p-0">
            <li class="!m-0 !text-sm !leading-relaxed !text-slate-600">
                <strong class="!text-slate-800">Pagamento a consumo:</strong>
                si paga solo per le risorse effettivamente utilizzate.
            </li>
            <li class="!m-0 !text-sm !leading-relaxed !text-slate-600">
                <strong class="!text-slate-800">Flessibilità:</strong>
                nessuna necessità di pacchetti in anticipo, le spese seguono le necessità.
            </li>
            <li class="!m-0 !text-sm !leading-relaxed !text-slate-600">
                <strong class="!text-slate-800">Vantaggi:</strong>
                ideale se il consumo è imprevedibile, con un risparmio rispetto a costi fissi inutilizzati.
            </li>
        </ul>
        <p class="!mb-0 !text-sm !leading-relaxed !text-slate-700">
            In sintesi, il pay-as-you-go è la soluzione a consumo per eccellenza:
            i costi restano allineati all'uso, senza esagerati costi fissi.
        </p>
    </section>

    <div class="plan-card-container" *ngIf="services && services.length">
        <div class="plan-header">
            <div>
                <h3 class="plan-title">Scegli il piano giusto per te</h3>
                <p class="plan-subtitle">
                    Prezzi semplici e trasparenti. Nessun costo nascosto.
                </p>
            </div>
            <div class="billing-toggle">
                <button type="button" class="billing-pill" [class.active]="billingPeriod === 'monthly'"
                        (click)="setBillingPeriod('monthly')">
                    Mensile
                </button>
                <button type="button" class="billing-pill" [class.active]="billingPeriod === 'yearly'"
                        (click)="setBillingPeriod('yearly')">
                    Annuale
                </button>
            </div>
        </div>

        <div class="plans-grid">
            <div class="plan-card" *ngFor="let service of services; let i = index"
                 [class.is-selected]="setCheckbox(service)"
                 (click)="selectPlan(service)">
                <div class="plan-badge" *ngIf="i === 1">
                    Più scelto
                </div>
                <h4 class="plan-name">
                    {{ service.name }}
                </h4>
                <div class="plan-billing-label">
                    {{ billingPeriod === 'monthly' ? 'Canone mensile' : 'Piano annuale' }}
                </div>
                <div class="plan-price">
                    <div class="plan-price-main">
                        <span class="amount">
                            {{ getDisplayedMonthlyPrice(service) | number:'1.2-2' }}€
                        </span>
                        <span class="period">
                            {{ billingPeriod === 'monthly' ? '/mese' : '/'+getServiceRecurrencyMonths(service)+' mesi' }}
                        </span>
                    </div>

                    <div *ngIf="billingPeriod === 'monthly' && getAnnualSavingsPercent(service) as savePct"
                         class="mt-3 flex items-center gap-2 rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-800">
                        <i class="bi bi-tag-fill" aria-hidden="true"></i>
                        <span>Risparmia il <strong>{{ savePct }}%</strong> con il piano annuale</span>
                    </div>

                    <div *ngIf="billingPeriod === 'yearly'" class="mt-3 space-y-1 text-sm text-slate-600">
                        <div class="flex items-baseline gap-1.5">
                            <span class="font-medium text-slate-800">~{{ getAnnualBilledMonthlyPrice(service) | number:'1.2-2' }}€/mese</span>
                        </div>
                        <div *ngIf="getAnnualSavingsPercent(service) as savePct"
                             class="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                            <i class="bi bi-check-circle-fill" aria-hidden="true"></i>
                            −{{ savePct }}% rispetto al mensile
                        </div>
                    </div>
                </div>
                <div class="mt-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600"
                     *ngIf="hasCustomSubscriptionTerms(service)">
                    <span *ngIf="service.customFeeRate != null">
                        Commissione: <strong>{{ service.customFeeRate * 100 | number:'1.1-2' }}%</strong>
                    </span>
                    <span *ngIf="service.customFeeRate != null && service.monthCount != null"> · </span>
                    <span *ngIf="service.monthCount != null">
                        Durata: <strong>{{ service.monthCount }} mesi</strong>
                    </span>
                </div>
                <ul class="plan-features">
                    <li *ngFor="let feature of service.features">{{ getFeatureLabel(feature) }}</li>
                </ul>
                <button type="button" class="btn w-100 plan-cta"
                        [ngClass]="setCheckbox(service) ? 'btn-dark' : 'btn-outline-dark'">
                    {{ setCheckbox(service) ? 'Piano selezionato' : 'Conferma piano' }}
                </button>
            </div>
        </div>

        <div class="mt-4 mb-4 rounded-lg bg-emerald-50 px-4 py-3 text-sm text-emerald-800"
             *ngIf="billingPeriod === 'yearly' && company.service && getAnnualSavingsPercent(company.service) as footnotePct">
            Stai risparmiando il <strong>{{ footnotePct }}%</strong> con il piano annuale.
        </div>

        <div class="tariff-card" *ngIf="tariffTiers && tariffTiers.length && !shouldHideStandardTariffTable()">
            <div class="tariff-header row g-0">
                <div class="col-7 col-md-8">
                    <span class="tariff-header-title">Esigenza</span>
                </div>
                <div class="col-5 col-md-4 text-end">
                    <span class="tariff-header-title">Tariffa</span>
                </div>
            </div>
            <div class="tariff-row row g-0" *ngFor="let tier of tariffTiers">
                <div class="col-7 col-md-8">
                    <span class="tariff-range"
                          [class.tariff-range-strong]="tier.range === 'Iscrizioni illimitate'">
                        {{ tier.range }}
                    </span>
                </div>
                <div class="col-5 col-md-4 text-end">
                    <span class="tariff-rate"
                          [class.tariff-rate-strong]="tier.range === 'Iscrizioni illimitate'">
                        {{ tier.rate }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="step-actions">
        <button type="button" class="btn-back" (click)="!isProcessing && previousStep()"
                [class.btn-back--disabled]="isProcessing">Indietro</button>
        <div class="step-actions-end">
            <p class="!mb-0 !w-full !text-right !text-sm !text-red-700"
               *ngIf="submitted && !hasSelectedPlan">Seleziona un piano per continuare.</p>
            <button class="btn-procedi" type="button" [disabled]="isProcessing" (click)="tryContinue()">
                <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ isProcessing ? 'Salvataggio...' : 'Salva e procedi' }}
            </button>
        </div>
    </div>
</div>
